import { render, staticRenderFns } from "./ComponentBannerCatalog.vue?vue&type=template&id=7ce26890&scoped=true"
import script from "./ComponentBannerCatalog.vue?vue&type=script&lang=js"
export * from "./ComponentBannerCatalog.vue?vue&type=script&lang=js"
import style0 from "./ComponentBannerCatalog.vue?vue&type=style&index=0&id=7ce26890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce26890",
  null
  
)

export default component.exports